export default __webpack_public_path__ + "static/media/four-input-benchy.8c92326c.svg";